import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import TextInput from "components/form/TextInput";
import FormButton from "components/form/FormButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { getLanguageString as _ } from "misc/lang";
import css from "./addsuborganisationsscreen.module.scss";

interface Props {
  title: string;
  subtitle?: string;
  inputValue: string;
  onInputChange: (value: string) => void;
  onAdd: () => void;
  error?: string;
  selectedEmails: string[];
  onRemove: (email: string) => void;
  cssModule?: { [key: string]: string };
}

const EmailAssign: React.FC<Props> = ({
  title,
  subtitle,
  inputValue,
  onInputChange,
  onAdd,
  error,
  selectedEmails,
  onRemove,
  cssModule,
}) => {
  const styles = cssModule || css;

  return (
    <Box className={styles.section}>
      <Typography variant="h6" className={styles.sectionTitle}>
        {title}
      </Typography>
      {subtitle && (
        <Typography fontSize={"12px"} fontWeight={400}>
          {subtitle}
        </Typography>
      )}

      <Box className={styles.emailInputContainer}>
        <TextInput
          label={_("organisation", "person_email")}
          placeholder={_("organisation", "placeholder_person_email")}
          labelOutside={true}
          isRequired={true}
          type="email"
          initialValue={inputValue}
          updateValue={(value) => onInputChange(value)}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              onAdd();
            }
          }}
        />
        <FormButton
          label={_("organisation", "add_button")}
          onSubmit={onAdd}
          inline={true}
          variant="contained"
          color="primary"
          size="large"
          dontTransformToUppercase
        />
      </Box>

      {error && <Typography className={styles.emailError}>{error}</Typography>}

      {selectedEmails.length > 0 && (
        <Box className={styles.selectedPersonsBox}>
          <Typography variant="subtitle2" className={styles.selectedTitle}>
            {_("organisation", "selected_persons")} ({selectedEmails.length})
          </Typography>
          <Box className={styles.personsList}>
            {selectedEmails.map((email, index) => (
              <Box key={index} className={styles.personItem}>
                <Typography className={styles.personEmail}>{email}</Typography>
                <IconButton
                  size="small"
                  onClick={() => onRemove(email)}
                  className={styles.deleteButton}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default EmailAssign;
